import { render, staticRenderFns } from "./WithoutRewardSection.vue?vue&type=template&id=30ad909e"
import script from "./WithoutRewardSection.vue?vue&type=script&lang=js"
export * from "./WithoutRewardSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports